// extracted by mini-css-extract-plugin
module.exports = {"container":"e_0x","pending":"e_1x","slider":"e_2x","imageContainer":"e_3x","image":"e_4x","button":"e_5x","prevButton":"e_6x","nextButton":"e_7x","disabled":"e_8x"};